import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SdSimpleResponsiveBannerComponent } from '../simple-responsive-banner';

@Component({
  selector: 'sd-timestamp-responsive-banner',
  templateUrl: './timestamp-responsive-banner.component.html',
  styleUrls: ['./timestamp-responsive-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})

// для хуиты под названием нупогоди нужен специфический баннер с часами
// на бэке это можно реализовать только экстендом.
// мы тоже экстендим, хули делать.
export class SdTimestampResponsiveBannerComponent extends SdSimpleResponsiveBannerComponent implements OnInit {
  clock: Date;

  ngOnInit(): void {
    super.ngOnInit();
    this.clock = new Date();
  }
}
